export class ConditionLoadValues {
    static $inject = ['$translate'];
    constructor($translate) {
        'ngInject';
        this.$translate = $translate;
    }
    async loadProperties() {
        return [
            {
                value: 'Message',
                label: await this.$translate('modules.application.detail.attendance.rules.property.message'),
            },
            {
                value: 'Contact.Name',
                label: await this.$translate('modules.application.detail.attendance.rules.property.contact.name'),
            },
            {
                value: 'Contact.Email',
                label: await this.$translate('modules.application.detail.attendance.rules.property.contact.email'),
            },
            {
                value: 'Contact.Extras',
                label: await this.$translate('modules.application.detail.attendance.rules.property.contact.extras'),
            },
        ];
    }
    async loadRelations() {
        return [
            {
                value: 'Contains',
                label: await this.$translate('modules.application.detail.attendance.rules.relation.contains'),
            },
            {
                value: 'NotContains',
                label: await this.$translate('modules.application.detail.attendance.rules.relation.notContains'),
            },
            {
                value: 'Equals',
                label: await this.$translate('modules.application.detail.attendance.rules.relation.equals'),
            },
            {
                value: 'NotEquals',
                label: await this.$translate('modules.application.detail.attendance.rules.relation.notEquals'),
            },
        ];
    }
    async loadOperators() {
        return [
            {
                value: 'Or',
                label: (await this.$translate('utils.misc.or')).toUpperCase(),
            },
            {
                value: 'And',
                label: (await this.$translate('utils.misc.and')).toUpperCase(),
            },
        ];
    }
}
ConditionLoadValues.$inject = ['$translate'];
